import { render, staticRenderFns } from "./AddToGroupModal.vue?vue&type=template&id=18aaceb9&scoped=true"
import script from "./AddToGroupModal.vue?vue&type=script&lang=js"
export * from "./AddToGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddToGroupModal.vue?vue&type=style&index=0&id=18aaceb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aaceb9",
  null
  
)

export default component.exports